import blank from '@/assets/images/blank.png';
import React, { useEffect } from 'react';


import usePageData from '@/api/hooks/usePageData';
import ProductExamples from '@/components/ProductExamples';
import WhyChooseUs from '@/components/WhyChooseUs';
import clsx from 'clsx';
import GlobeLoading from '@/components/GlobeLoading';
import { Helmet } from 'react-helmet-async';
 

const Main: React.FC = () => { 

  const {
    page,
    data: pageData,
    isLoading: isLoadingPage,
    localization
  } = usePageData();


  useEffect(() => {
    if (isLoadingPage) {
      return;
    }
    var revapi;
    revapi = jQuery('.tp-banner').revolution(
      {
        delay: 9000,
        startwidth: 1170,
        startheight: 576,
        hideThumbs: 200,
        fullWidth: "on",
        forceFullWidth: "on"
      });
  }, [isLoadingPage]);

  return (
    <div>
      <Helmet>
        <title>
          {localization?.dict["page.title"]?.value}
        </title>
        <meta name="description" content={
          localization?.dict["page.description"]?.value
        } />
        <meta name="keywords" content={
          localization?.dict["page.keywords"]?.value
        } />
      </Helmet>
      <GlobeLoading isLoading={isLoadingPage} />
      <section className="slider-revolution clearfix" data-stellar-background-ratio="0.3">
        <div className="slider-revolution-overlay"></div>

        <div id="content-index" className="no-margin-top">
          <div className="container">
            <div className="tp-banner-container">
              <div className="tp-banner">
                <ul>
                  {pageData?.Slider?.map((item: any, index: any) => {
                    const images = item.related?.map((related: any) => {
                      return {
                        src: related.image,
                        alt: related.title
                      }
                    });
                    return (
                      <>
                        <li
                          key={"slider" + index + item.title}
                          data-transition="fade" data-slotamount="10" data-thumb="">
                          <img src={blank} alt="" />
                          {images.map((image: any, index: any) => {
                            return (
                              <div
                                key={index + 'image' + image.src + image.alt}
                                className={clsx('caption', index === 0 ? 'lfr' : index === 1 ? 'sfb' : index === 2 ? 'lfr' : 'lfr')}
                                data-x={index === 0 ? 860 : index === 1 ? 610 : index === 2 ? 590 : 900}
                                data-y={index === 0 ? 80 : index === 1 ? 250 : index === 2 ? 120 : 300}
                                data-speed={2000}
                                data-start={1300}
                                data-easing="easeOutBack"
                              >
                                <img src={image.src} alt={image.alt} className="img-circle"
                                  style={{
                                    width: '238px',
                                    height: '237px'
                                  }}
                                />
                              </div>
                            )
                          })}
                          <div
                            className="caption lft big_white"
                            data-x="0"
                            data-y="130"
                            data-speed="1500"
                            data-start="1700"
                            data-easing="easeOutExpo"
                          >
                            {item.title}
                          </div>

                          <div
                            className="caption sfr medium_grey"
                            data-x="0"
                            data-y="200"
                            data-speed="1000"
                            data-start="2500"
                            data-easing="easeOutExpo"
                            dangerouslySetInnerHTML={{ __html: item.content }}
                          ></div>

                          <div
                            className="caption sfb"
                            data-x="8"
                            data-y="430"
                            data-speed="500"
                            data-start="2500"
                            data-easing="easeOutExpo"
                          >
                            <a className="btn btn-rounded btn-bordered">
                              <div dangerouslySetInnerHTML={{ __html: localization.dict["slider.more"].value }}></div>
                            </a>
                          </div>
                        </li>
                      </>
                    )
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section >

      <section className="creative-sec" style={{ backgroundImage: 'none' }}>
        <div className="container">
          <div className="text-center">
            <h1 className="light">{localization?.dict["hero.title"].value}</h1>
            <p className="lead" dangerouslySetInnerHTML={{ __html: localization?.dict["hero.content"].value }}></p>
          </div>
        </div>
      </section>

      <section className="medicom-awesome-features-sec" data-stellar-background-ratio="0.3">
        <div className="medico-awesome-features-sec-overlay"></div>
        <div className="container">
          <div className="text-center">
            <h1 className="light" dangerouslySetInnerHTML={{ __html: localization?.dict["solutions.title"]?.value }}>
            </h1>
            <p className="lead">{localization?.dict["solutions.description"]?.value}</p>
          </div>

          <ul className="awesome-features list-unstyled pull-left text-right">
            <li>
              <i className="pull-right img-circle fa fa-ambulance"></i>
              <span>{localization?.dict["solutions.word.1.title"]?.value} </span>
              <div dangerouslySetInnerHTML={{ __html: localization?.dict["solutions.word.1.description"]?.value }}></div>
            </li>
            <li className="middle">
              <i className="pull-right img-circle fa fa-eye"></i>
              <span>{localization?.dict["solutions.word.2.title"]?.value} </span>
              <div dangerouslySetInnerHTML={{ __html: localization?.dict["solutions.word.2.description"]?.value }}></div>
            </li>
            <li>
              <i className="pull-right img-circle fa fa-flask"></i>
              <span>{localization?.dict["solutions.word.3.title"]?.value} </span>
              <div dangerouslySetInnerHTML={{ __html: localization?.dict["solutions.word.3.description"]?.value }}></div>
            </li>
          </ul>

          <ul className="awesome-features list-unstyled pull-right text-left">
            <li>
              <i className="pull-left img-circle fa fa-user-md"></i>
              <span>{localization?.dict["solutions.word.4.title"]?.value} </span>
              <div dangerouslySetInnerHTML={{ __html: localization?.dict["solutions.word.4.description"]?.value }}></div>
            </li>
            <li className="middle">
              <i className="pull-left img-circle fa fa-heart"></i>
              <span>{localization?.dict["solutions.word.5.title"]?.value} </span>
              <div dangerouslySetInnerHTML={{ __html: localization?.dict["solutions.word.5.description"]?.value }}></div>
            </li>
            <li>
              <i className="pull-left img-circle fa fa-tint"></i>
              <span>{localization?.dict["solutions.word.6.title"]?.value} </span>
              <div dangerouslySetInnerHTML={{ __html: localization?.dict["solutions.word.6.description"]?.value }}></div>
            </li>
          </ul>
        </div>
      </section>

      <div className="height40"></div>

      <div className="container">
        <div className="row">
          <div className="col-md-7">
                <ProductExamples
                  title={localization?.dict["product.examples.title"]?.value}
                  data={pageData?.Products}
                  readMoreLink={localization?.dict["product.examples.readmore.link"]?.value}
                  readMoreText={localization?.dict["product.examples.readmore"]?.value}
                />
          </div>

          <div className="col-md-5">
            <WhyChooseUs
              title={localization?.dict["whychooseus.title"]?.value}
              data={pageData?.WhyChooseUs}
            />
          </div>
        </div>
      </div>
    </div >
  );
};

export default Main;
